import { Button, Form, Input } from "antd";
import { memo } from "react";
import { Modal } from "react-bootstrap";

const CallProviderModal = ({
  selectedCallProvider,
  isCallProviderModalOpen = false,
  handleToggleCallProvider,
  handleSubmitForm,
}) => {
  const [form] = Form.useForm();
  const onFinish = (values) => {
    handleSubmitForm(selectedCallProvider?.id, values);
  };
  const isNew = selectedCallProvider ? false : true;

  const initialValues = isNew
    ? {
        providerName: "",
        config: null,
      }
    : {
        providerName: selectedCallProvider?.provider_name,
        config: selectedCallProvider?.config
          ? JSON.stringify(selectedCallProvider?.config, null, 2)
          : null,
      };

  const isJSON = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };
  return (
    <Modal
      show={isCallProviderModalOpen}
      onHide={() => handleToggleCallProvider()}
    >
      <Modal.Header closeButton>
        <Modal.Title>{isNew ? "Add" : "Edit"} Call Provider</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          form={form}
          layout="vertical"
          initialValues={initialValues}
          onFinish={onFinish}
        >
          <Form.Item
            name="providerName"
            label="Provider Name"
            rules={[
              {
                required: true,
                message: "Please input Provider Name!",
              },
            ]}
          >
            <Input placeholder="Enter Provider Name" />
          </Form.Item>

          <Form.Item
            name="config"
            label="Config"
            rules={[
              {
                required: false,
                message: "Please input Config!",
              },
              () => ({
                validator(_, value) {
                  if (value && !isJSON(value)) {
                    return Promise.reject(
                      "JSON is invalid. Please check your input."
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input.TextArea
              placeholder="Enter the Config here"
              rows={10}
              cols={10}
            />
          </Form.Item>

          <div className="d-flex gap-2 justify-content-end border-top pt-4">
            <Form.Item>
              <Button
                variant="secondary"
                onClick={() => handleToggleCallProvider()}
              >
                Close
              </Button>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                {isNew ? "Add New" : "Save Changes"}
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default memo(CallProviderModal);
